export enum CalculationType {
  Addition = 'addition',
  Substraction = 'substraction',
  Multiplication = 'multiplication'
}
